import { AddIcon, PenIcon } from '@systemeio/ui/icons'
import { Modal, ModalSizeEnum, PrimaryButton, Tooltip } from '@systemeio/ui'
import { SmsTemplateForm, SmsTemplateFormProps } from 'modules/sms/components/sms-template-form'
import { useSmsTemplate } from 'modules/sms/hooks/use-sms-template'
import { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useModal } from 'shared/hooks/use-modal'

interface Props extends Pick<SmsTemplateFormProps, 'templateId' | 'onSuccess'> {
  noRedirectOnNotFoundError?: boolean
}

export function SmsTemplateCreateEditModal({
  templateId,
  onSuccess,
  noRedirectOnNotFoundError,
}: Props) {
  const { t } = useLocoTranslation()
  const modal = useModal()
  const { template } = useSmsTemplate(templateId, noRedirectOnNotFoundError)
  const [isFetching, setIsFetching] = useState(false)

  return (
    <>
      {templateId ? (
        <Tooltip mode={'hover'} label={t('dashboard.automation_rule.edit.edit_sms')}>
          <button onClick={() => modal.open()} className={'group outline-hidden'}>
            <PenIcon
              className={
                'fill-fill-primary main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary h-[16px] w-[16px]'
              }
            />
          </button>
        </Tooltip>
      ) : (
        <Tooltip mode={'hover'} label={t('dashboard.automation_rule.edit.create_sms')}>
          <button onClick={() => modal.open()} className={'group outline-hidden'}>
            <AddIcon
              className={
                'fill-fill-primary main-transition-colors group-hover:fill-brand-primary group-focus-visible:fill-brand-primary'
              }
            />
          </button>
        </Tooltip>
      )}

      <Modal
        size={ModalSizeEnum.big}
        title={
          templateId ? t('dashboard.sms.edit_sms_template') : t('dashboard.sms.create_sms_template')
        }
        opened={modal.opened}
        onClose={modal.close}
        contentClassName="flex flex-col"
        isFetching={isFetching}
      >
        <SmsTemplateForm
          templateId={templateId}
          data={template}
          inModal
          onStatusChange={({ isFetching }) => setIsFetching(isFetching)}
          onSuccess={async data => {
            await onSuccess?.(data)
            modal.close()
          }}
        />

        <PrimaryButton
          form={SmsTemplateForm.formId}
          className="mt-10 self-center"
          isFetching={isFetching}
        >
          {t('global.save')}
        </PrimaryButton>
      </Modal>
    </>
  )
}
